import React from "react";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import { Paper } from "@mui/material";
import { FaQrcode } from "react-icons/fa";
import { Bitcoin, Tether, Ethereum } from "cryptocons";
import { AdminPanelSettings as AdminIcon } from "@mui/icons-material";
import { useAuth } from "contexts/AuthContext";
import { Logout as LogoutIcon } from "@mui/icons-material";
import { isMobile } from "react-device-detect";

function BottomBar({ value, setValue, onQrClick, onAdminClick }: any) {
  const { signOut } = useAuth();

  return (
    <Paper sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}
      elevation={3}
    >
      <BottomNavigation
        showLabels
        value={value}
        onChange={(event, newValue) => {
          setValue(9999);
          setTimeout(() => {
            setValue(newValue);
          }, 0);
        }}
        sx={{ position: "relative", height: 60, paddingBottom: 0 }}
      >
        <BottomNavigationAction label={"USDT"} icon={<Tether size={24} />} />
        <BottomNavigationAction
          label={"USDC"}
          icon={
            <img src={"/images/svg/usd-coin-usdc-logo.svg"} width={24} alt="" />
          }
        />
        <BottomNavigationAction
          label={"FDUSD"}
          icon={
            <img
              src={"/images/svg/first-digital-usd-fdusd-logo.svg"}
              width={24}
              alt=""
            />
          }
        />
        <BottomNavigationAction label={"BTC"} icon={<Bitcoin size={24} />} />
        <BottomNavigationAction label={"ETH"} icon={<Ethereum size={24} />} />
        <BottomNavigationAction label={"QR"} icon={<FaQrcode size={24} />} />
        {isMobile && onAdminClick && (
          <BottomNavigationAction
            label={"Quản trị"}
            icon={<AdminIcon sx={{ fontSize: 24 }} />}
            onClick={onAdminClick}
            sx={{ color: "#34d399" }}
          />
        )}
        {/* <BottomNavigationAction label={"U"} icon={<Ethereum size={24} />} /> */}
        <BottomNavigationAction
          label={"Đăng xuất"}
          icon={<LogoutIcon sx={{ fontSize: 24 }} />}
          onClick={() => signOut()}
          sx={{ color: "error.main" }}
        />
        {/* <BottomNavigationAction
          label={"ADA"}
          icon={
            <div style={{ background: "white", padding: 5, borderRadius: 20 }}>
              <img
                src="/images/svg/cardano-ada-logo.svg"
                alt="USDT"
                width="20"
              ></img>
            </div>
          }
        /> */}

        {/* QR overlay: intercepts clicks before BottomNavigation sees them */}
        <div
          role="button"
          tabIndex={0}
          onClick={(e) => {
            e.stopPropagation();
            onQrClick?.();
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              e.stopPropagation();
              onQrClick?.();
            }
          }}
          style={{
            position: "absolute",
            right: `${(100 / 6)}%`,
            bottom: 0,
            top: 0,
            width: `${100 / 6}%`,
            cursor: "pointer",
            zIndex: 10,
          }}
        />
      </BottomNavigation>
    </Paper>
  );
}

export default BottomBar;
